<template>
  <div>
    <Row justify="start" type="flex">
      <Col class="buy_col01" v-for="(item, index) in photoArr1" :key="index">
        <div class="buy_rule" @click="getMoney(item)">
          <img :src="item.photoUrl" alt="#" />
        </div>
        <div @click="getMoney(item)" class="sp">{{ item.ref }}</div>
        <div style="font-size: 18px; color: #f12344; margin-bottom: 6px">
          <Button type="primary" @click="getMoney(item)">了解更多</Button>
        </div>
      </Col>
    </Row>
    <!--对话框-->
    <div>
      <Modal
        class="modal_div"
        v-model="modal1"
        :title="ref"
        width="80%"
        class-name="vertical-center-modal"
        @on-visible-change="onChange"
      >
        <div slot="header">
          <Row>
            <Col span="20">
              <span class="header_div">{{ this.ref }}</span>
            </Col>
          </Row>
        </div>
        <div class="wid_img">
          <img
            src="../../../static/img/Buy/ThreeDimensional/three.jpg"
            alt="暂无图片"
          />
        </div>
        <div slot="footer">
          <Button @click="modal1 = false">取消</Button>
        </div>
      </Modal>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      modal1: false,
      item01: [],
      ref: "",
      photoArr1: [
        {
          photoUrl: "../../../static/img/photo/photo_guizi.jpg",
          photoUrl1: "../../../static/img/photo-da/photo_guizi.jpg",
          ref: "32/42/55寸透明屏液晶展柜触摸互动透明屏展示柜拼接透明屏显示器",
          money: "￥30000.00",
          classify: [
            {
              type: "",
              money: "￥30000.00",
              img: "../../../static/img/photo-da/photo_guizi.jpg",
            },
          ],
          title: "工法质量样板三维立体展示柜",
          belong: "互动透明屏展示柜",
          path: "/home/Buy/ThreeDimensional",
        },
      ],
    };
  },
  methods: {
    onChange() {
      document
        .querySelector("body")
        .setAttribute("style", "overflow:hidden;padding-right:15px");
    },
    /*弹出对话框*/
    getMoney(item) {
      this.modal1 = true;
      this.item01 = item;
      this.ref = item.ref;
    },
    /*刚进页面的立即购买*/
    getMoney01(item) {
      this.goBuy(item);
    },
    /*弹出框里面立即购买*/
    goBuyGo() {
      this.modal1 = false;
      this.goBuy(this.item01);
      document.querySelector("body").setAttribute("style", "overflow:auto");
    },
    /*购买*/
    goBuy(item) {
      sessionStorage.setItem("title", item.title);
      sessionStorage.setItem("belong", item.belong);
      sessionStorage.setItem("path", item.path);
      sessionStorage.setItem("money", item.money);
      sessionStorage.setItem("ref", item.ref);
      sessionStorage.setItem("photoUrl1", item.photoUrl1);
      sessionStorage.setItem("classify", JSON.stringify(item.classify));
      this.$router.push({
        path: "/home/buyGo",
      });
    },
  },
};
</script>
<style>
.modal_div .ivu-modal-header p,
.modal_div .ivu-modal-header-inner {
  color: #02a0e7;
  font-size: 20px;
  font-weight: bold;
  font-family: 新宋体, serif;
}

/*面包屑*/
.col_bread .ivu-breadcrumb {
  font-size: 16px;
}
</style>
<style scoped>
/*弹出框字体*/
.header_div {
  color: #02a0e7;
  font-size: 20px;
  font-weight: bold;
  font-family: 新宋体, serif;
}

/*弹出框字体*/
.font_size {
  font-size: 19px;
}

.buy_col01 {
  width: 270px;
  background: #f7f7f7;
  text-align: center;
  cursor: pointer;
  margin: 14px 0px 0 22px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.2);
  border-radius: 6px;
}

.buy_col01:hover {
  box-shadow: 0 0 3px 3px rgba(0, 0, 0, 0.2);
}

.buy_col01 .sp:hover {
  color: red;
}

.buy_rule {
  width: 270px;
  height: 240px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.buy_rule img {
  width: 210px;
  height: 210px;
}

.sp {
  font-size: 14px;
  height: 40px;
}

.wid_img {
  display: flex;
  justify-content: center;
  align-items: center;
}

.wid_img img {
  width: 80%;
}
</style>



// WEBPACK FOOTER //
// src/components/Buy/ThreeDimensional.vue